module.exports = __webpack_public_path__ + "img/example-2.68f9dd99.png";